import React, { useState } from "react";
import * as cls from "./signUp.module.scss";
import authImg from "../../resources/images/authorization.png";
import { useNavigate } from "react-router-dom";
import Reload from "../../resources/icons/Reload";
import { AuthorizationService } from "../authorizationService";
import { Icon } from "../../../personal-studio-components/frame";
import { useDispatch } from "react-redux";
import { authErrorAction, changeStepAction } from "../../redux/actions/actions";
import { Button } from "../../../personal-studio-components/form";
import PolicyFooter from "../policyFooter/PolicyFooter";

export default function SignUp({
  setCurrpage,
  step,
  // setStep,
  paramsToken,
  signUpVideoGuide,
}) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [captchaUrl, setCaptchaUrl] = useState(null);
  const [captchaUuid, setCaptchaUuid] = useState(null);
  const [inputValue, setInputValue] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [paswdVisible, setPaswdVisible] = useState(false);
  const [paswdVisible2, setPaswdVisible2] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  function failed(data) {
    const err = data;
    const errorEvent = new ErrorEvent("error", {
      error: err,
    });
    window.dispatchEvent(errorEvent);
    dispatch(authErrorAction(true));
  }
  const onKeyUp = (event) => {
    if (event.code === "NumpadEnter" || event.code === "Enter") {
      switch (step) {
        case 0:
          handleGetCaptcha();
          break;
        case 1:
          handleSendCaptcha();
          break;
        case 3:
          signUpConfirm();
      }
    }
  };
  const handleGetCaptcha = async () => {
    if (!email) {
      setErrorMessage("Заполните поле логин");
      return;
    }
    const request = {
      method: "post",
      path: "/registration/captcha",
      data: {
        email,
      },
    };
    const data = await AuthorizationService.send(request, (response) => {});
    if (!data.errors) {
      const { captcha_url, captcha_uuid } = data;
      setCaptchaUrl(captcha_url);
      setCaptchaUuid(captcha_uuid);
      dispatch(changeStepAction(1));
      setErrorMessage("");
    } else {
      const err = data;
      const errorEvent = new ErrorEvent("error", {
        error: err,
      });
      window.dispatchEvent(errorEvent);
      return;
    }
  };
  const handleSendCaptcha = async () => {
    const request = {
      method: "post",
      path: "/registration/request",
      data: {
        email,
        captcha_uuid: captchaUuid,
        captcha_data: inputValue,
      },
    };
    const data = await AuthorizationService.send(request, (response) => {});
    if (data.errors) {
      if (
        data.errors[0] ===
        "Ошибка: Пользователь с данным электронным адресом уже зарегистрирован."
      ) {
        failed(data);
        return;
      }
      handleGetCaptcha();
      return;
    }
    dispatch(changeStepAction(2));
  };
  const signUpConfirm = async () => {
    if (password !== passwordConfirm) {
      setErrorMessage("Пароли не совпадают");
      return;
    }
    setErrorMessage("");
    const request = {
      method: "post",
      path: "/registration/confirm",
      data: {
        token: paramsToken,
        password,
      },
    };

    const data = await AuthorizationService.send(request, (response) => {});
    if (data.errors) {
      failed(data);
      return;
    }
    navigate("/");
    setCurrpage("signIn");
  };

  return (
    <div className={cls.root}>
      <div className={cls.imgContainer}>
        <img src={authImg} />
      </div>
      <div className={cls.logWrapper}>
        <div className={cls.logContainer} onKeyUp={onKeyUp}>
          <div className={cls.header}>
            {step === 2 &&
              "На указанную электронную почту был отправлен новый пароль для входа"}
            {step < 2 && "Регистрация"}
            {step === 3 && "Придумайте пароль"}
          </div>
          <div className={cls.body}>
            {step < 2 && (
              <div className={cls.login}>
                <span className={cls.gray_text}>Логин</span>

                <input
                  autoFocus
                  autoComplete="off"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  placeholder="Введите свой логин"
                />
                <span className={cls.invalid_login}>{errorMessage}</span>
              </div>
            )}
            {step === 3 && (
              <>
                <div className={cls.password}>
                  <span className={cls.gray_text}>Придумайте пароль</span>
                  <input
                    autoFocus
                    autoComplete="off"
                    value={password}
                    onChange={(event) => setPassword(event.target.value)}
                    placeholder="Введите пароль"
                    type={paswdVisible ? "" : "password"}
                  />
                  <div
                    className={cls.password_control}
                    onClick={() => setPaswdVisible((prev) => !prev)}
                  >
                    <Icon
                      name={paswdVisible ? "eye_invisible" : "eye_visible"}
                      className={cls.icon}
                    />
                  </div>
                </div>
                <div className={cls.password}>
                  <span className={cls.gray_text}>Повторите пароль</span>
                  <input
                    value={passwordConfirm}
                    onChange={(event) => setPasswordConfirm(event.target.value)}
                    type={paswdVisible2 ? "" : "password"}
                    placeholder="Повторите пароль"
                  />
                  <div
                    className={cls.password_control}
                    onClick={() => setPaswdVisible2((prev) => !prev)}
                  >
                    <Icon
                      name={paswdVisible2 ? "eye_invisible" : "eye_visible"}
                      className={cls.icon}
                    />
                  </div>
                </div>
                <span className={cls.invalid_login}>{errorMessage}</span>
              </>
            )}
          </div>
          <div className={cls.captchaContainer}>
            {step === 1 && captchaUrl && (
              <>
                <div className={cls.imgContainer}>
                  <img className={cls.img} src={captchaUrl} alt="" />
                  <div onClick={handleGetCaptcha} className={cls.reload}>
                    <Reload />
                  </div>
                </div>
                <div className={cls.login}>
                  <span className={cls.gray_text}>Введите текст из капчи</span>
                  <input
                    autoFocus
                    autoComplete="off"
                    value={inputValue}
                    onChange={(event) => setInputValue(event.target.value)}
                  />
                </div>
              </>
            )}
          </div>
          <div className={cls.btnContainer}>
            {/* <div className={cls.signPrimary}> */}
            {/* {step === 0 && <button onClick={handleGetCaptcha}>Далее</button>} */}
            {step === 0 && (
              <Button type="primary" onClick={handleGetCaptcha}>
                Далее
              </Button>
            )}
            {/* {step === 1 && (
              
              <button onClick={handleSendCaptcha}>Подтвердить</button>
            )} */}
            {step === 1 && (
              <Button type="primary" onClick={handleSendCaptcha}>
                Подтвердить
              </Button>
            )}
            {/* </div> */}
            {/* {step < 2 && (
              <div className={cls.signSecondary}>
              <button
                onClick={() => {
                  setCurrpage("signIn");
                  dispatch(changeStepAction(0));
                }}
              >
                Войти
              </button>
              </div>
            )} */}
            {step < 2 && (
              <Button
                onClick={() => {
                  setCurrpage("signIn");
                  dispatch(changeStepAction(0));
                }}
              >
                Войти
              </Button>
            )}
            {/* {step === 3 && (
              <div className={cls.signPrimary}>
                <button onClick={signUpConfirm}>Зарегистрироваться</button>
              </div>
            )} */}
            {step === 3 && (
              <Button type="primary" onClick={signUpConfirm}>
                Зарегистрироваться
              </Button>
            )}
          </div>
          <div style={{ marginTop: "15px", textAlign: "center" }}>
            <a
              href={signUpVideoGuide}
              target="_blank"
              rel="noopener noreferrer"
            >
              Видеоинструкция по регистрации в Личном кабинете обучающегося
            </a>
          </div>
        </div>
        <div className={cls.policyFooter}>
          <PolicyFooter />
        </div>
      </div>
    </div>
  );
}
